module.exports = __webpack_public_path__ + "img/banner_es.9cdf8ed0.jpg";